<template>

  <div id="app">

    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>

      <v-card color="grey lighten-4" flat>

        <v-layout row wrap>

          <v-flex xs12 md12 sm12>

            <v-toolbar size="120px" dark color="info">

              <v-toolbar-title>{{ $t('Turnover-Analysis-Report') }}</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn color="pink lighten-1" dark @click="openMailDialog" small>

  <v-icon left>email</v-icon> {{ $t('Send-Mail') }}

</v-btn>

              <v-menu bottom="" left>

                <v-btn slot="activator" dark icon>

                  <v-icon>more_vert</v-icon>

                </v-btn>

                <v-list>

                  <v-list-tile @click="getListHtml()">

                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>

                  </v-list-tile>



                  <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">

                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>

                  </v-list-tile>

                </v-list>

              </v-menu>

            </v-toolbar>

          </v-flex>

<!-- MAIL GÖNDER DIALOG -->

<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>

  <v-card>

    <v-toolbar dense flat color="info" dark>

      <v-toolbar-title>{{ $t('Send-Mail') }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>

    </v-toolbar>

    <v-card-text>

      <v-form ref="mailForm" v-model="mailValid" lazy-validation>

        <v-layout wrap>

          <v-flex xs12>

            <v-text-field

              v-model="mailPayload.To"

              :label="$t('Recipient-Email')"

              :rules="[rules.required, rules.email]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgencyName"

              :label="$t('Agency-Name')"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.DocType"

              :label="$t('Fixed-Document-Type')"

              :rules="[rules.required]"

              :disabled="true"

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgentFullName"

              :label="$t('Agent-Full-Name')"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12>

            <v-textarea

              v-model="mailPayload.CustomBody"

              :label="$t('Message')"

              :rules="[rules.required]"

              auto-grow

              rows="3"

            ></v-textarea>

          </v-flex>

        </v-layout>

      </v-form>

    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>

      <v-spacer></v-spacer>

      <v-btn flat @click="closeMailDialog">{{ $t('Cancel') }}</v-btn>

      <v-btn

        color="info"

        :loading="mailLoading"

        :disabled="!mailValid || mailLoading"

        @click="sendMail"

      >

        <v-icon left>send</v-icon>{{ $t('Send') }}

      </v-btn>

    </v-card-actions>

  </v-card>

</v-dialog>



          <v-container fluid>



            <v-layout row wrap>

              <v-flex pb-3 xs12 sm12 md12>

                <v-card flat>

                  <v-form ref="formgunluksatis" v-model="valid" lazy-validation>

                    <v-layout row wrap>

                      <v-flex sm2 md2 pl-1 pt-2>

                        <v-autocomplete clearable="" v-model="Rapor.Yil" :label="$t('YEAR')" :items="tarihitems"

                          :rules="[v => !!v || $t('Mandatory-section')]" cache-items=""> </v-autocomplete>

                      </v-flex>

                      <v-flex pt-2>

                        <v-layout>

                          <div v-if="load1">

                            <v-btn color="info" @click="getList()" fab small="" dark>

                              <v-icon>search</v-icon>

                            </v-btn>

                          </div>

                          <div v-if="progress">

                            <v-layout pt-3 align-center="">

                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>

                            </v-layout>

                          </div>

                          <v-badge color="white" :overlap="true">

                            <template v-slot:badge>

                              <v-icon v-if="filtrevarmi" large color="green">

                                check_circle_outline </v-icon>

                            </template>

                            <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"

                              @click="filtrele()" color="info" fab dark>

                              <v-icon>filter_list</v-icon>

                            </v-btn>

                            <v-tooltip bottom="" :activator="el" v-model="tooltip">

                              <span>{{$t('Add-Search-Filter')}}</span>

                            </v-tooltip>





                          </v-badge>

                        </v-layout>

                      </v-flex>

                    </v-layout>

                  </v-form>

                </v-card>

              </v-flex>

              <v-flex xs12 v-if="itemssatis.length>0" sm12 md12>

                <v-layout row wrap>

                  <v-flex xs12 pa-1 sm12 md12>

                    <v-toolbar flat="" size="120px" dark color="white">

                      <v-toolbar-title> <span class="subheading grey--text">

                          <v-icon color="grey">view_list</v-icon> {{ $t('List-Turnover-Current-Account') }}

                        </span> </v-toolbar-title>

                      <v-spacer></v-spacer>

                    </v-toolbar>

                  </v-flex>

                  <v-flex xs12 sm12 md6 pa-1 v-for="item in itemssatis" :key="item.id ">

                    <v-card flat>

                      <v-layout row wrap class="pa-3 project overdue">

                        <v-flex pt-1 pb-1 sm112 xs12 md12>

                          <v-layout row wrap>

                            <v-flex pa-1 sm10 xs12 md9>

                              <div class="subtitle-2 font-weight-   grey--text">

                                <v-icon color="grey">account_box </v-icon> &nbsp; {{item.Cari.Kod}}-{{item.Cari.Unvan}}

                              </div>

                            </v-flex>

                            <v-flex xs12 sm2 md3>

                              <v-layout wrap align-center fill-height justify-center="">

                                <v-flex xs12 sm12 md12>

                                  <v-layout justify-center="">

                                    <span class="body-1 red--text font-weight-">

                                      {{item.ToplamTutar | moneyformat }}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                  <v-divider></v-divider>

                                  <v-layout justify-center="">

                                    <span class="caption grey--text ">

                                      {{ $t('Total-Revenue') }}

                                    </span>

                                  </v-layout>

                                </v-flex>

                              </v-layout>

                            </v-flex>

                          </v-layout>

                        </v-flex>

                        <v-flex xs12 md12>

                          <v-divider></v-divider>

                        </v-flex>

                        <v-flex xs12 md12>

                          <v-layout row wrap>

                            <v-flex xs12 md6>

                              <v-layout row wrap>

                                <v-flex xs12 sm12 md6>

                                  <v-layout row wrap>

                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-left>

                                        <div class="caption  justify-center   grey--text">{{ $t('January') }} :</div>

                                      </v-layout>

                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-end>

                                        <div class="justify-end align-center fill-height caption ">

                                          {{item.OcakTutar | moneyformat }}{{getparabirimi()}}</div>

                                      </v-layout>

                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-left>

                                        <div class="caption  justify-center   grey--text">{{ $t('February') }} :</div>

                                      </v-layout>

                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-end>

                                        <div class="justify-end caption ">{{item.SubatTutar | moneyformat }}{{getparabirimi()}}</div>

                                      </v-layout>

                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-left>

                                        <div class="caption  justify-center   grey--text">{{ $t('March') }} :</div>

                                      </v-layout>

                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-end>

                                        <div class="justify-end caption ">{{item.MartTutar | moneyformat }}{{getparabirimi()}}</div>

                                      </v-layout>

                                    </v-flex>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md6>

                                  <v-layout row wrap>

                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-left>

                                        <div class="justify-center caption grey--text"> {{ $t('April') }} :</div>

                                      </v-layout>

                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-end>

                                        <div class="justify-center caption ">{{item.NisanTutar | moneyformat }}{{getparabirimi()}}</div>

                                      </v-layout>

                                    </v-flex>







                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-left>

                                        <div class="justify-center caption grey--text">{{ $t('May') }} :</div>

                                      </v-layout>

                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-end>

                                        <div class="justify-center caption ">{{item.MayisTutar | moneyformat }}{{getparabirimi()}}</div>

                                      </v-layout>

                                    </v-flex>



                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-left>

                                        <div class="justify-center caption grey--text">{{ $t('June') }}:</div>

                                      </v-layout>

                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-end>

                                        <div class="justify-center caption ">{{item.HaziranTutar | moneyformat }}{{getparabirimi()}}</div>

                                      </v-layout>

                                    </v-flex>

                                  </v-layout>

                                </v-flex>

                              </v-layout>

                            </v-flex>

                            <v-flex xs12 md6>

                              <v-layout row wrap>



                                <v-flex xs12 sm12 md6>

                                  <v-layout row wrap>

                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-left>

                                        <div class="caption  justify-center   grey--text">{{ $t('July') }} :</div>

                                      </v-layout>

                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-end>

                                        <div class="justify-end caption">{{item.TemmuzTutar | moneyformat }}{{getparabirimi()}}</div>

                                      </v-layout>

                                    </v-flex>



                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-left>

                                        <div class="caption  justify-center   grey--text">{{ $t('August') }}  :</div>

                                      </v-layout>

                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-end>

                                        <div class="justify-end caption ">{{item.AgustosTutar | moneyformat }}{{getparabirimi()}}</div>

                                      </v-layout>

                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-left>

                                        <div class="caption  justify-center   grey--text">{{ $t('September') }}:</div>

                                      </v-layout>

                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-end>

                                        <div class="justify-end caption ">{{item.EylulTutar | moneyformat }}{{getparabirimi()}}</div>

                                      </v-layout>

                                    </v-flex>





                                  </v-layout>

                                </v-flex>



                                <v-flex xs12 sm12 md6>

                                  <v-layout row wrap>

                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-left>

                                        <div class="justify-center caption grey--text">{{ $t('October') }}:</div>

                                      </v-layout>

                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-end>

                                        <div class="justify-center caption ">{{item.EkimTutar | moneyformat }}{{getparabirimi()}}</div>

                                      </v-layout>

                                    </v-flex>







                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-left>

                                        <div class="justify-center caption grey--text">{{ $t('November') }}:</div>

                                      </v-layout>

                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-end>

                                        <div class="justify-center caption ">{{item.KasimTutar | moneyformat }}{{getparabirimi()}}</div>

                                      </v-layout>

                                    </v-flex>



                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-left>

                                        <div class="justify-center caption grey--text"> {{ $t('December') }}:</div>

                                      </v-layout>

                                    </v-flex>

                                    <v-flex pa-1 xs6 md6>

                                      <v-layout justify-end>

                                        <div class="justify-center caption ">{{item.AralikTutar | moneyformat }}{{getparabirimi()}}</div>

                                      </v-layout>

                                    </v-flex>

                                  </v-layout>

                                </v-flex>

                              </v-layout>

                            </v-flex>

                          </v-layout>

                        </v-flex>

                      </v-layout>

                      <v-divider></v-divider>

                    </v-card>



                  </v-flex>

                </v-layout>

              </v-flex>



              <br />



              
              <v-flex xs12 v-if="itemssatis.length>0" sm12 md12 pa-1>
                <div class="ciro-analiz-report-table">
                  <ReportTable
                    :headers="headers"
                    :items="ciroAnalizReportItems"
                    storage-key="ciroanaliz_columns"
                    :loading="progress"
                    :has-searched="itemssatis && itemssatis.length > 0"
                    :show-search="true"
                    :search-label="$t('Search')"
                    :show-frontend-export="true"
                    :export-title="$t('Turnover-Analysis-Report')"
                    :export-meta-items="ciroAnalizExportMetaItems"
                    :export-summary-cards="ciroAnalizSummaryCards"
                    :rows-per-page-items="[20, 50, 100, 250, 500, 1000]"
                  ></ReportTable>
                </div>
              </v-flex>

<v-flex xs12 v-if="itemssatis.length>0" sm12 md12 pa-1>

                <v-card flat class="white--text">

                  <v-card flat="">

                    <v-card-actions>

                      <v-layout row wrap>

                        <v-flex xs12 sm12 md12>

                          <v-toolbar flat="" size="120px" dark color="white">

                            <v-toolbar-title> <span class="subheading grey--text">

                                <v-icon color="grey">show_chart</v-icon> {{ $t('Grand-Total') }} :

                                {{genelToplamCiro | moneyformat }}{{getparabirimi()}}

                              </span> </v-toolbar-title>

                            <v-spacer></v-spacer>

                          </v-toolbar>

                        </v-flex>

                        <v-flex xs12 md12>

                          <ve-histogram :data="chartData" :judge-width="true" :settings="chartSettings"></ve-histogram>

                        </v-flex>





                      </v-layout>

                    </v-card-actions>

                  </v-card>

                </v-card>

              </v-flex>

            </v-layout>

          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"

            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">

            {{ text1 }}

            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>

          </v-snackbar>





          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">

            <v-card color="grey lighten-5">

              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>

              <v-divider></v-divider>

              <v-card-text>

                <v-layout row="" wrap="">



                  <v-flex xs12 sm12 md12 pa-1>

                    <v-card class="white--text">

                      <v-card color="grey lighten-5" flat="">

                        <v-card-actions>

                          <v-layout row="" wrap="">

                            <v-flex xs12 sm12 md12>



                            <cariaracomp v-bind:etiket="$t('Main-Account')" v-bind:value="Rapor.AnaHesap" :loading="loadingana" v-model="Rapor.AnaHesap"></cariaracomp>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <v-select :items="hesapgrubu" hide-details="" v-model="Rapor.HesapGrubu"

                                :label="$t('Account-Group-Requested')" multiple item-text="Adi" item-value="Kod"

                                max-height="400"></v-select>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <v-select :items="nohesapgrubu" hide-details="" v-model="Rapor.NoHesapGrubu"

                                :label="$t('Account-Group-Not-Requested')" multiple item-text="Adi" item-value="Kod"

                                max-height="400"></v-select>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                            <cariaracomp v-bind:etiket="$t('Currentcode_label')" v-bind:value="Rapor.Cari.Kod" :loading="loading" v-model="Rapor.Cari.Kod"></cariaracomp>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <!-- <v-select :items="referansitems" hide-details v-model="Rapor.Referanslar"

                                :label="$t('Reference')" multiple item-text="Title" item-value="Kod">

                                <template slot="selection" slot-scope="{ item, index }">

                                  <v-chip v-if="index === 0">

                                    <h4> <span>{{ item.Kod }}</span> </h4>

                                  </v-chip>

                                  <span v-if="index === 1" class="grey--text caption">(+{{

                                  Rapor.Referanslar - 1 }} {{ $t('other-record') }})</span>

                                </template>

                              </v-select> -->

                              <referansmerkezicomp :coper="false" :tabdeger="'37'" v-model="ReferansPrm.Kod" >

                              </referansmerkezicomp>

                            </v-flex>





                            <v-flex xs12 sm12 md12>

                              <v-checkbox :label="$t('Deduct-Current-VAT-Amount')" v-model="Rapor.CariKdvTutar" hide-details="">

                              </v-checkbox>

                              <v-checkbox :label="$t('Account-Name')" v-model="Rapor.HesapAdi" hide-details=""></v-checkbox>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>

                            </v-flex>

                          </v-layout>

                        </v-card-actions>

                      </v-card>

                    </v-card>

                  </v-flex>





                </v-layout>

              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>

                <v-spacer></v-spacer>

                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>

                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>

              </v-card-actions>

            </v-card>

          </v-dialog>

        </v-layout>

      </v-card>

    </v-app>

  </div>

</template>



<script>

  import auth from '../../../api/auth'

  import tarihcomp from '../customcomp/tarihim'

  import helpers from "@/components/app/customcomp/helpers.js"

  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"

  import VeBar from 'v-charts/lib/bar.common'

  import VeHistogram from 'v-charts/lib/histogram.common'

  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"

  import cariaracomp from '@/components/app/customcomp/cariaracomp'
  import ReportTable from "@/components/app/customcomp/ReportTable.vue"





  export default {

    data() {

      return {

        mailDialog: false,

mailValid: false,

mailLoading: false,

mailPayload: {

  To: "",

  AgencyName: "",

  DocType: "",

  AgentFullName: "",

  CustomBody: ""

},

rules: {

  required: v => !!v || this.$t('Required-Field'),

  email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || this.$t('Enter-Valid-Email')

},

        PB:'TRY',

        sayfayetki: {

          Screen: false,

          Update: false,

          Save: false,

          Delete: false,

          Status: false,

          Message: null,

          islem: 0,

        },

        ReferansPrm: {

                Kod: null},

        genelToplamCiro: 0,

        chartData: {

          columns: ['ay', 'Revenue'],

          rows: [{

              'ciro': 10,

              'ay': this.$t('January')

            },

            {

              'ciro': 20,

              'ay': this.$t('February')

            },

            {

              'ciro': 5,

              'ay': this.$t('March')

            },

            {

              'ciro': 1,

              'ay': this.$t('April')

            },

            {

              'ciro': 26,

              'ay': this.$t('May')

            },

            {

              'ciro': 10,

              'ay': this.$t('June')

            },

            {

              'ciro': 20,

              'ay': this.$t('July')

            },

            {

              'ciro': 5,

              'ay': this.$t('August')

            },

            {

              'ciro': 1,

              'ay': this.$t('September')

            },

            {

              'ciro': 26,

              'ay': this.$t('October')

            },

            {

              'ciro': 10,

              'ay': this.$t('November')

            },

            {

              'ciro': 20,

              'ay': this.$t('December')

            }

          ]

        },

        chartSettings: {

          colors: ['#F44336'],

          label: {

            normal: {

              show: true,

              position: "top"

            }

          },

          yAxisName: [this.$t('Total-Revenue')],

          yAxisType: ['0']

        },







        filtrevarmi: false,

        referansitems: [],

        search: '',

        searchsatilanbilet: null,

        tarihitems: [2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010,

          2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028,

          2029, 2030

        ],
        headers: [{
            text: this.$t('Currentcode_label'),
            value: '_CariKod',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'left',
            width: '160px'
          },
          {
            text: this.$t('Title_label'),
            value: '_CariUnvan',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'left',
            width: '280px'
          },
          { text: this.$t('January'), value: 'OcakTutar', visible: true, sortable: true, type: 'money', align: 'right', width: '140px' },
          { text: this.$t('February'), value: 'SubatTutar', visible: true, sortable: true, type: 'money', align: 'right', width: '140px' },
          { text: this.$t('March'), value: 'MartTutar', visible: true, sortable: true, type: 'money', align: 'right', width: '140px' },
          { text: this.$t('April'), value: 'NisanTutar', visible: true, sortable: true, type: 'money', align: 'right', width: '140px' },
          { text: this.$t('May'), value: 'MayisTutar', visible: true, sortable: true, type: 'money', align: 'right', width: '140px' },
          { text: this.$t('June'), value: 'HaziranTutar', visible: true, sortable: true, type: 'money', align: 'right', width: '140px' },
          { text: this.$t('July'), value: 'TemmuzTutar', visible: true, sortable: true, type: 'money', align: 'right', width: '140px' },
          { text: this.$t('August'), value: 'AgustosTutar', visible: true, sortable: true, type: 'money', align: 'right', width: '140px' },
          { text: this.$t('September'), value: 'EylulTutar', visible: true, sortable: true, type: 'money', align: 'right', width: '140px' },
          { text: this.$t('October'), value: 'EkimTutar', visible: true, sortable: true, type: 'money', align: 'right', width: '140px' },
          { text: this.$t('November'), value: 'KasimTutar', visible: true, sortable: true, type: 'money', align: 'right', width: '140px' },
          { text: this.$t('December'), value: 'AralikTutar', visible: true, sortable: true, type: 'money', align: 'right', width: '140px' },
          { text: this.$t('Total-Revenue'), value: 'ToplamTutar', visible: true, sortable: true, type: 'money', align: 'right', width: '170px' }
        ],
        headers2: [{

            text: this.$t('January'),

            value: 'GenelOcakTutar',

          },

          {

            text: this.$t('February'),

            value: 'GenelSubatTutar',

          },

          {

            text: this.$t('March'),

            value: 'GenelMartTutar',

          },

          {

            text: this.$t('April'),

            value: 'GenelNisanTutar',

          },

          {

            text: this.$t('May'),

            value: 'GenelMayisTutar',

          },

          {

            text: this.$t('June'),

            value: 'GenelHaziranTutar',

          },

          {

            text: this.$t('July'),

            value: 'GenelTemmuzTutar',

          },

          {

            text: this.$t('August'),

            value: 'GenelAgustosTutar',

          },

          {

            text: this.$t('September'),

            value: 'GenelEylulTutar',

          },

          {

            text: this.$t('October'),

            value: 'GenelEkimTutar',

          },

          {

            text: this.$t('November'),

            value: 'GenelKasimTutar',

          },

          {

            text: this.$t('December'),

            value: 'GenelAralikTutar',

          },

          {

            text: this.$t('Grand-Total'),

            value: 'GenelToplamTutar',

          }

        ],

        GenelToplamlar: [],



        hesapgrubu: [],

        nohesapgrubu: [],

        Rapor: {

          AnaHesap: null,

          HesapGrubu: [],

          NoHesapGrubu: [],

          Yil: null,

          CariKdvTutar: false,

          HesapAdi: false,

          Cari: {

            Kod: null,

          },

          SirketKodu: null,

          Referanslar: [],

        },





        valid: true,

        tumsirketler: '',

        loadingana: false,

        loading: false,

        items: [],

        load: false,

        load1: true,

        search3: '',

        renk1: 'info',

        dialogfiltre: false,

        hesapkodu: [],

        statecari: [],

        searchcari: '',

        statecariana: [],

        searchcariana: '',

        progress: false,

        tooltip: false,

        el: null,

        yok: false,

        itemssatis: [],

        butondurum: true,

        snackbar: false,

        y: 'top',

        x: 'right',

        mode: '',

        timeout: 6000,

        text1: '',

        dictionary: {

          custom: {

            tarihsec: {

              required: () => this.$t('Please-select-a-date')

            },

            tarihsec1: {

              required: () => this.$t('Please-select-a-date')

            },

          }

        },

      }

    },

    beforeRouteEnter(to, from, next) {

      next(vm => {

        vm.prevRoute = from.path

      })

    },

    beforeMount: beforeMount,

    mounted() {

      this.$validator.localize('en', this.dictionary)

      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {



        this.Rapor.Yil = helpers.getYear();

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.PB=credentials.ParaBirimi

        var params3 = {

          CompanyCode: credentials.SirketKodu

        }



        this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {

          headers: {

            'Authorization': 'Bearer ' + auth.getAuthHeader()

          }

        }).then((response) => {

          this.hesapgurubu = response.body

          this.nohesapgrubu = response.body

        }, (response) => {

          if (response.status === 0) {

            this.text1 = this.$t('Service-Unavailable')

            this.snackbar = true

          } else {

            this.text1 = this.$t('Service-Unavailable')

            this.snackbar = true

          }

        })



        // this.$http.post(auth.API_URL + 'api/Reference/List', params3, {

        //   headers: {

        //     'Authorization': 'Bearer ' + auth.getAuthHeader()

        //   }

        // }).then((response) => {

        //   this.referansitems = response.body

        // }, (response) => {

        //   if (response.status === 0) {

        //     this.text1 = 'Service Unavailable'

        //     this.snackbar = true

        //   } else {

        //     this.text1 = 'Service Unavailable'

        //     this.snackbar = true

        //   }

        // })





        var params4 = {

          CompanyCode: credentials.SirketKodu

        }

        this.$http.post(auth.API_URL + 'api/doctype/List', params4, {

          headers: {

            'Authorization': 'Bearer ' + auth.getAuthHeader()

          }

        }).then((response) => {

          this.evraktipi = response.body

        }, (response) => {

          if (response.status === 0) {

          } else {

          }

        })





      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {

              var url = '#' + this.prevRoute

              window.open(url, '_self')

            } else {

              var url = '#/'

              window.open(url, '_self')

            }

          } else {

          }

        });

      }

    },

    filters: {

      dateformat: function (t) {

        return helpers.dateformat(t);

      },

      moneyformat: function (m) {

        return helpers.moneyformat(m);

      },

      bakiyekontrol: function (m) {

        return helpers.bakiyekontrol(m);

      }

    },

    components: {

      'tarihcomp': tarihcomp,

      referansmerkezicomp,

      VeBar,

      VeHistogram,

      yetkidialog,

      cariaracomp,
      ReportTable

    },


    computed: {
      ciroAnalizReportItems() {
        var list = Array.isArray(this.itemssatis) ? this.itemssatis : []

        return list.map(function (item) {
          var row = Object.assign({}, item)
          row._CariKod = item && item.Cari ? item.Cari.Kod : ''
          row._CariUnvan = item && item.Cari ? item.Cari.Unvan : ''
          return row
        })
      },

      ciroAnalizExportMetaItems() {
        return [
          { label: this.$t('YEAR'), value: this.Rapor ? this.Rapor.Yil : '' },
          { label: this.$t('Main-Account'), value: this.Rapor ? this.Rapor.AnaHesap : '' },
          { label: this.$t('Currentcode_label'), value: this.Rapor && this.Rapor.Cari ? this.Rapor.Cari.Kod : '' },
          { label: this.$t('Deduct-Current-VAT-Amount'), value: this.Rapor && this.Rapor.CariKdvTutar ? this.$t('Yes') : this.$t('No') },
          { label: this.$t('Account-Name'), value: this.Rapor && this.Rapor.HesapAdi ? this.$t('Yes') : this.$t('No') },
          { label: this.$t('All-Companies'), value: this.tumsirketler === true ? this.$t('Yes') : this.$t('No') }
        ]
      },

      ciroAnalizSummaryCards() {
        var row = Array.isArray(this.GenelToplamlar) && this.GenelToplamlar.length
          ? this.GenelToplamlar[0]
          : null

        if (!row) {
          return [
            {
              title: this.$t('Grand-Total'),
              items: [
                { label: this.$t('Total-Revenue'), value: this.genelToplamCiro, type: 'money' }
              ]
            }
          ]
        }

        return [
          {
            title: this.$t('Grand-Total'),
            items: [
              { label: this.$t('January'), value: row.GenelOcakTutar, type: 'money' },
              { label: this.$t('February'), value: row.GenelSubatTutar, type: 'money' },
              { label: this.$t('March'), value: row.GenelMartTutar, type: 'money' },
              { label: this.$t('April'), value: row.GenelNisanTutar, type: 'money' },
              { label: this.$t('May'), value: row.GenelMayisTutar, type: 'money' },
              { label: this.$t('June'), value: row.GenelHaziranTutar, type: 'money' },
              { label: this.$t('July'), value: row.GenelTemmuzTutar, type: 'money' },
              { label: this.$t('August'), value: row.GenelAgustosTutar, type: 'money' },
              { label: this.$t('September'), value: row.GenelEylulTutar, type: 'money' },
              { label: this.$t('October'), value: row.GenelEkimTutar, type: 'money' },
              { label: this.$t('November'), value: row.GenelKasimTutar, type: 'money' },
              { label: this.$t('December'), value: row.GenelAralikTutar, type: 'money' },
              { label: this.$t('Total-Revenue'), value: row.GenelToplamTutar, type: 'money' }
            ]
          }
        ]
      }
    },

    watch: {

    },

    methods: {

  getparabirimi() {

    return helpers.getparabirimi();

  },

  openMailDialog() {

    if (!this.mailPayload) this.mailPayload = {};

    this.mailPayload.DocType = this.$t('Turnover-Analysis-Report');

    if (this.$refs && this.$refs.mailForm && this.$refs.mailForm.resetValidation) {

      this.$refs.mailForm.resetValidation();

    }

    this.mailDialog = true;

  },

  closeMailDialog() {

    this.mailDialog = false;

  },

  sendMail() {

    if (!(this.$refs && this.$refs.mailForm && this.$refs.mailForm.validate && this.$refs.mailForm.validate())) return;

    if (!(this.$refs && this.$refs.formgunluksatis && this.$refs.formgunluksatis.validate && this.$refs.formgunluksatis.validate())) return;

    var credsRaw = window.localStorage.getItem('credentials');

    var creds = credsRaw ? JSON.parse(credsRaw) : {};

    var companyCode = this.tumsirketler === true ? '0' : (creds && creds.SirketKodu ? creds.SirketKodu : null);

    var R = JSON.parse(JSON.stringify(this.Rapor || {}));

    R.SirketKodu = companyCode;

    var refArr = [];

    if (this.ReferansPrm && this.ReferansPrm.Kod) refArr.push({ Kod: this.ReferansPrm.Kod });

    if (Array.isArray(R.Referanslar) && R.Referanslar.length > 0) {

      R.Referanslar.forEach(k => refArr.push(typeof k === "string" ? { Kod: k } : k));

    }

    R.Referanslar = refArr;

    var mp = this.mailPayload || {};

    var payload = {

      Input: R,

      Mail: {

        To: mp.To || "",

        AgencyName: mp.AgencyName || "",

        DocType: mp.DocType || this.$t('Turnover-Analysis-Report'),

        AgentFullName: mp.AgentFullName || "",

        CustomBody: mp.CustomBody || ""

      }

    };

    this.mailLoading = true;

    var endpoint = auth.API_URL + 'api/Report/MailGonderAnalyseReportrExcel';

    this.$http.post(endpoint, payload, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } })

      .then(() => {

        this.mailLoading = false;

        this.mailDialog = false;

        this.text1 = this.$t('Mail-Sent');

        this.snackbar = true;

      }, (err) => {

        this.mailLoading = false;

        var body = (err && (err.body || err.data)) ? (err.body || err.data) : {};

        var msg = (body && (body.Message || body.message)) || err.statusText || this.$t('Mail-Could-Not-Be-Sent');

        this.text1 = msg;

        this.snackbar = true;

      });

  },

      getList: getList,

      getListHtml: getListHtml,

      getListExcel: getListExcel,

      filtrele: filtrele,

      filtrekayit: filtrekayit,

      filtreiptal: filtreiptal,

    }

  }



  function filtrele() {

    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {

      CompanyCode: credentials.SirketKodu

    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.itemsairlinelist = response.body

    }, (response) => {

      if (response.status === 0) {

        this.text1 = this.$t('Service-Unavailable')

        this.progress = false

        this.snackbar = true

      } else {

        this.text1 = this.$t('Service-Unavailable')

        this.progress = false

        this.snackbar = true

      }

    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.hesapgrubu = response.body

    }, (response) => {

      if (response.status === 0) {

        this.text1 = this.$t('Service-Unavailable')

        this.snackbar = true

      } else {

        this.text1 = this.$t('Service-Unavailable')

        this.snackbar = true

      }

    })

    this.$http.post(auth.API_URL + 'api/currency/List', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.doviztipi = response.body

    }, (response) => {

      if (response.status === 0) {

        this.text1 = this.$t('Service-Unavailable-Currency')

        this.snackbar = true

      } else {

        this.text1 = this.$t('Service-Unavailable-Currency')

        this.snackbar = true

      }

    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.masrafmerkezi = response.body

    }, (response) => {

      if (response.status === 0) {

      } else {

      }

    })



  }







  function filtrekayit() {

    this.filtrevarmi = true

    this.dialogfiltre = false

    this.getList()

  }

  function filtreiptal() {

    this.filtrevarmi = false

    this.dialogfiltre = false

    this.Rapor.SirketKodu = null

    this.Rapor.Cari.Kod = null

    this.Rapor.Evraklar = []

    this.Rapor.Referanslar = []

    this.Rapor.Tip = '0'

  }



  function getList() {

    if (this.$refs.formgunluksatis.validate()) {



      this.progress = true

      this.chartData.rows = []

      this.load1 = false

      var listreferans = [];

      this.Rapor.Referanslar=[];

      if (this.ReferansPrm.Kod!='' && this.ReferansPrm.Kod!=null)

      {

        this.Rapor.Referanslar.push(this.ReferansPrm.Kod);

      }

      this.Rapor.Referanslar.forEach(element => {

        var kayit = {

          Kod: element

        }

        listreferans.push(kayit)

      });

      this.Rapor.Referanslar = listreferans





      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler === true) {

        this.Rapor.SirketKodu = '0'

      } else {

        this.Rapor.SirketKodu = credentials.SirketKodu

      }



      var params = this.Rapor

      this.$http.post(auth.API_URL + 'api/Report/EndorsementAnalyseReport', params, {

        headers: {

          'Authorization': 'Bearer ' + auth.getAuthHeader()

        }

      }).then((response) => {

        this.GenelToplamlar = []



        this.genelToplamCiro = response.body.GenelToplamTutar

        this.GenelToplamlar.push(response.body)

        this.itemssatis = response.body.CiroAnalizDetay

        var toplamkayit = []

        var kayit = {

          Revenue : response.body.GenelOcakTutar,

          ay: 'January'

        }

        this.chartData.rows.push(kayit)

        kayit = {

          Revenue : response.body.GenelSubatTutar,

          ay: 'february'

        }

        this.chartData.rows.push(kayit)

        kayit = {

          Revenue : response.body.GenelMartTutar,

          ay: 'March'

        }

        this.chartData.rows.push(kayit)

        kayit = {

          Revenue : response.body.GenelNisanTutar,

          ay: 'April'

        }

        this.chartData.rows.push(kayit)

        kayit = {

          Revenue : response.body.GenelMayisTutar,

          ay: 'May'

        }

        this.chartData.rows.push(kayit)

        kayit = {

          Revenue : response.body.GenelHaziranTutar,

          ay: 'June'

        }

        this.chartData.rows.push(kayit)

        kayit = {

          Revenue : response.body.GenelTemmuzTutar,

          ay: 'July'

        }

        this.chartData.rows.push(kayit)

        kayit = {

          Revenue : response.body.GenelAgustosTutar,

          ay: 'Agust'

        }

        this.chartData.rows.push(kayit)

        kayit = {

          Revenue : response.body.GenelEylulTutar,

          ay: 'September'

        }

        this.chartData.rows.push(kayit)

        kayit = {

          Revenue : response.body.GenelEkimTutar,

          ay: 'October'

        }

        this.chartData.rows.push(kayit)

        kayit = {

          Revenue : response.body.GenelKasimTutar,

          ay: 'November'

        }

        this.chartData.rows.push(kayit)

        kayit = {

          Revenue : response.body.GenelAralikTutar,

          ay: 'December'

        }

        this.chartData.rows.push(kayit)











        this.progress = false

        this.load1 = true

      }, (response) => {

        if (response.status === 0) {

          this.text1 = this.$t('Service-Unavailable')

          this.snackbar = true

          this.progress = false

          this.load1 = true

        } else {

          this.text1 = this.$t('Service-Unavailable')

          this.snackbar = true

          this.progress = false

          this.load1 = true

        }

      })

    }

  }





  function getListHtml() {



    if (this.$refs.formgunluksatis.validate()) {



      this.progress = true

      this.load1 = false

      var listreferans = [];

      this.Rapor.Referanslar=[];

      if (this.ReferansPrm.Kod!='' && this.ReferansPrm.Kod!=null)

      {

        this.Rapor.Referanslar.push(this.ReferansPrm.Kod);

      }

      this.Rapor.Referanslar.forEach(element => {

        var kayit = {

          Kod: element

        }

        listreferans.push(kayit)

      });

      this.Rapor.Referanslar = listreferans



      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      var lang = localStorage.getItem('lang')

      if (this.tumsirketler === true) {

        this.Rapor.SirketKodu = '0'

      } else {

        this.Rapor.SirketKodu = credentials.SirketKodu

      }

      var params = this.Rapor

      this.$http

        .post(auth.API_URL + "api/Report/EndorsementAnalyseReportHtml", params, {

          headers: {

            Authorization: "Bearer " + auth.getAuthHeader()

          }

        }).then((response) => {

          this.GenelToplamlar = []

          this.GenelToplamlar.push(response.body)

          this.itemssatis = response.body.CiroAnalizDetay

          this.progress = false

          this.load1 = true

          if (lang=='en')

          {

            var bodyhtml=helpers.getTranslatedHtml(response.bodyText);

             bodyhtml=bodyhtml.toString().replace('<title> CİRO ANALİZ RAPORU </title>','<title> TURNOVER ANALYSIS REPORT </title>');

             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>CİRO ANALİZ RAPORU</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>TURNOVER ANALYSIS REPORT</font>")

             bodyhtml=bodyhtml.toString().replace("Yıl :","Year :");

             bodyhtml=bodyhtml.toString().replace("Aylık Total :","Montly Total :");

             response.bodyText=bodyhtml;

          }

          var blob = new Blob([response.bodyText], {

            type: 'application/html'

          });

          var link = document.createElement('a');

          link.href = window.URL.createObjectURL(blob);

          link.download = this.$t('CiroAnalizRaporu') + ".html";

          link.click();

        }, (response) => {

          if (response.status === 0) {

            this.text1 = this.$t('Service-Unavailable')

            this.snackbar = true

            this.progress = false

            this.load1 = true

          } else {

            this.text1 = this.$t('Service-Unavailable')

            this.snackbar = true

            this.progress = false

            this.load1 = true

          }

        })

    }

  }



  function getListExcel() {



    if (this.$refs.formgunluksatis.validate()) {



      this.progress = true

      this.load1 = false

      var listreferans = [];

      this.Rapor.Referanslar=[];

      if (this.ReferansPrm.Kod!='' && this.ReferansPrm.Kod!=null)

      {

        this.Rapor.Referanslar.push(this.ReferansPrm.Kod);

      }

      this.Rapor.Referanslar.forEach(element => {

        var kayit = {

          Kod: element

        }

        listreferans.push(kayit)

      });

      this.Rapor.Referanslar = listreferans



      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler === true) {

        this.Rapor.SirketKodu = '0'

      } else {

        this.Rapor.SirketKodu = credentials.SirketKodu

      }

      var params = this.Rapor

      this.$http

        .post(auth.API_URL + "api/Report/EndorsementAnalyseReportExcel", params, {

          headers: {

            Authorization: "Bearer " + auth.getAuthHeader()

          },

          responseType: "arraybuffer"

        }).then((response) => {

          this.GenelToplamlar = []

          this.GenelToplamlar.push(response.body)

          this.itemssatis = response.body.CiroAnalizDetay

          this.progress = false

          this.load1 = true

          var blob = new Blob([response.data], {

            type: 'application/xlsx'

          });

          var link = document.createElement('a');

          link.href = window.URL.createObjectURL(blob);

          link.download = this.$t('CiroAnalizRaporu') + ".xlsx";

          link.click();

        }, (response) => {

          if (response.status === 0) {

            this.text1 = this.$t('Service-Unavailable')

            this.snackbar = true

            this.progress = false

            this.load1 = true

          } else {

            this.text1 = this.$t('Service-Unavailable')

            this.snackbar = true

            this.progress = false

            this.load1 = true

          }

        })

    }

  }



  function beforeMount() {

  }

</script>

<style scoped>

.project.complete {

    border-left: 4px solid #039BE5;

  }

  .project.ongoing {

    border-left: 4px solid orange;

  }

  .project.overdue {

    border-left: 4px solid tomato;

  }

/* Bu stiller yalnızca ciroanaliz.vue sayfasına özeldir. */
.ciro-analiz-report-table {
  width: 100%;
  margin-top: 4px;
}

.ciro-analiz-report-table > * {
  width: 100%;
}

</style>
